export class Model {
    id?: number | string;
    text?: string;
    metadata?: any;

    constructor(data : any){
        Object.assign(this, data);
    }
}
